import { createSlice } from "@reduxjs/toolkit";

export const suppressionSlice = createSlice({
  name: "suppression",
  initialState: {
    // GET Schedules
    isFetchingSchedules: false,
    schedules: null,
    fetchSchedulesError: null,

    // GET Frameworks
    isFetchingFrameworks: false,
    frameworks: null,
    fetchFrameworksError: null,

    // GET Controls
    isFetchingControls: false,
    controls: null,
    fetchControlsError: null,

    // GET Checks
    isFetchingChecks: false,
    checks: null,
    fetchChecksError: null,

    // GET Suppressions
    isFetchingSuppressions: false,
    suppressions: null,
    fetchSuppressionsError: null,

    // POST Bulk Suppressions
    isSavingSuppressions: false,
    saveSuppressionsError: null,
    saveSuppressionsSuccess: null,
  },
  reducers: {
    // 🔄 GET Schedules
    getSchedules: (state) => {
      state.isFetchingSchedules = true;
      state.fetchSchedulesError = null;
    },
    getSchedulesSuccess: (state, action) => {
      state.isFetchingSchedules = false;
      state.schedules = action.payload;
    },
    getSchedulesFailure: (state, action) => {
      state.isFetchingSchedules = false;
      state.fetchSchedulesError = action.payload;
    },

    // 🔄 GET Frameworks
    getFrameworks: (state) => {
      state.isFetchingFrameworks = true;
      state.fetchFrameworksError = null;
    },
    getFrameworksSuccess: (state, action) => {
      state.isFetchingFrameworks = false;
      state.frameworks = action.payload;
    },
    getFrameworksFailure: (state, action) => {
      state.isFetchingFrameworks = false;
      state.fetchFrameworksError = action.payload;
    },

    // 🔄 GET Controls
    getControls: (state) => {
      state.isFetchingControls = true;
      state.fetchControlsError = null;
    },
    getControlsSuccess: (state, action) => {
      state.isFetchingControls = false;
      state.controls = action.payload;
    },
    getControlsFailure: (state, action) => {
      state.isFetchingControls = false;
      state.fetchControlsError = action.payload;
    },

    // 🔄 GET Checks
    getChecks: (state) => {
      state.isFetchingChecks = true;
      state.fetchChecksError = null;
    },
    getChecksSuccess: (state, action) => {
      state.isFetchingChecks = false;
      state.checks = action.payload;
    },
    getChecksFailure: (state, action) => {
      state.isFetchingChecks = false;
      state.fetchChecksError = action.payload;
    },

    // 🔄 GET Suppressions
    getSuppressions: (state) => {
      state.isFetchingSuppressions = true;
      state.fetchSuppressionsError = null;
    },
    getSuppressionsSuccess: (state, action) => {
      state.isFetchingSuppressions = false;
      state.suppressions = action.payload;
    },
    getSuppressionsFailure: (state, action) => {
      state.isFetchingSuppressions = false;
      state.fetchSuppressionsError = action.payload;
    },

    // 🔄 POST Bulk Suppressions
    bulkUpsertSuppressions: (state) => {
      state.isSavingSuppressions = true;
      state.saveSuppressionsError = null;
      state.saveSuppressionsSuccess = null;
    },
    bulkUpsertSuppressionsSuccess: (state, action) => {
      state.isSavingSuppressions = false;
      state.saveSuppressionsSuccess = action.payload;
    },
    bulkUpsertSuppressionsFailure: (state, action) => {
      state.isSavingSuppressions = false;
      state.saveSuppressionsError = action.payload;
    },

    // ♻️ RESET
    clearSuppressionMessages: (state) => {
      state.fetchSchedulesError = null;
    },

    clearBulkSuppressionMessages: (state) => {
      state.saveSuppressionsError = null;
      state.saveSuppressionsSuccess = null;
    },

    clearSuppressionState: (state) => {
      state.schedules = null;
      state.fetchSchedulesError = null;
      state.frameworks = null;
      state.fetchFrameworksError = null;
      state.controls = null;
      state.fetchControlsError = null;
      state.checks = null;
      state.fetchChecksError = null;
      state.suppressions = null;
      state.fetchSuppressionsError = null;
      state.saveSuppressionsError = null;
      state.saveSuppressionsSuccess = null;
    },
  },
});

export const {
  getSchedules,
  getSchedulesSuccess,
  getSchedulesFailure,
  getFrameworks,
  getFrameworksSuccess,
  getFrameworksFailure,
  getControls,
  getControlsSuccess,
  getControlsFailure,
  getChecks,
  getChecksSuccess,
  getChecksFailure,
  getSuppressions,
  getSuppressionsSuccess,
  getSuppressionsFailure,
  bulkUpsertSuppressions,
  bulkUpsertSuppressionsSuccess,
  bulkUpsertSuppressionsFailure,
  clearSuppressionMessages,
  clearBulkSuppressionMessages,
  clearSuppressionState,
} = suppressionSlice.actions;

export default suppressionSlice.reducer;

